module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/product-images/product-05-0b19b66d0591dbd69e4d865b85757e10.webp";